import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { LocalStorageService } from 'ngx-webstorage';
import { SDTK } from '../../../../model/quote/sdtk/sdtk.model';
import { SDTKService } from '../../sdtk.service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-sdtk-full-details',
  templateUrl: './sdtk-full-details.component.html',
  styleUrls: ['./sdtk-full-details.component.css']
})
export class SdtkFullDetailsComponent implements OnInit {
  coverLimitOptions = [];
  cover_limit: string = '';
  building_name: string = '';
  formFields: FormGroup;
  is_selected: boolean = false;
  constructor(
    private sdtkService: SDTKService,
    private fb: FormBuilder
  ) { }
  quote;
  quoteApplicationData = new SDTK();
  CoverTo;
  @Input() set quoteDetails(value: any) {
    if (value) {
      this.quote = value;
      if (value.sdtk_questions.storage_location == 1) {
        this.building_name = 'BUILDING';
      }
      else {
        this.building_name = 'SHIPPING CONTAINER	';
      }
    }
    if (this.coverLimitOptions.length > 0) {
      this.updateSelectedCoverLimit();
    }
  }

  ngOnInit(): void {
    this.getCoverLimits();
  }
  public getCoverLimits() {
    this.sdtkService.getSDTKRatingOptions()
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.coverLimitOptions = response.result;
            this.coverLimitOptions = response.result.map(option => ({
              ...option,
              is_selected: false
            }));

            // Update selected option if quote data is available
            this.updateSelectedCoverLimit();
          }
        },
        (error) => {
          console.error('Error fetching cover limits:', error);
        }
      );
  }
  // Helper method to update the selected cover limit
  private updateSelectedCoverLimit() {
    if (this.quote && this.quote.sdtk_option_id && this.coverLimitOptions.length > 0) {
      this.coverLimitOptions.forEach(option => {
        option.is_selected = (option.id === this.quote.sdtk_option_id);
      });
    }
  }
  getCoverLimitName(optionId: number): string {
    const option = this.coverLimitOptions.find(opt => opt.id === optionId);
    return option ? option.name : '';
  }
}
